import { KpiSeriesWithImage } from "../../shared/types";

export const truncateText = (value: string, maxChars: number): string => {
  if (value.length <= maxChars) return value;
  return `${value.slice(0, maxChars - 3)}...`;
};

export const getTotalNulls = (series?: KpiSeriesWithImage[] | null) => {
  return series?.reduce((acc, s) => {
    if (s.years === null) {
      return acc + 1;
    }
    return acc;
  }, 0);
};
